define(["exports", "react", "../../utils/useRovingTabIndex"], function (_exports, _react, _useRovingTabIndex2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = TabProvider;
  _exports.useTabContext = useTabContext;
  _react = _interopRequireWildcard(_react);
  _useRovingTabIndex2 = _interopRequireDefault(_useRovingTabIndex2);
  var TabContext = /*#__PURE__*/(0, _react.createContext)();

  function TabProvider(_ref) {
    var children = _ref.children,
        initialKey = _ref.initialKey;

    var _useRovingTabIndex = (0, _useRovingTabIndex2.default)(initialKey),
        refMap = _useRovingTabIndex.refMap,
        handleKeyDown = _useRovingTabIndex.handleKeyDown,
        handleClick = _useRovingTabIndex.handleClick,
        currentKey = _useRovingTabIndex.currentKey;

    return /*#__PURE__*/_react.default.createElement(TabContext.Provider, {
      value: {
        refMap: refMap,
        handleKeyDown: handleKeyDown,
        handleClick: handleClick,
        currentKey: currentKey
      }
    }, children);
  }

  function useTabContext() {
    var context = (0, _react.useContext)(TabContext);

    if (context === undefined) {
      throw new Error('Tab e Panel devem ser utilizados dentro de um TabProvider');
    }

    return context;
  }

  TabProvider.defaultProps = {
    initialKey: null
  };
});